export const SET_SEAT_OPTIONS = 'SET_SEAT_OPTIONS';

export const POSITION_SEAT_OPTION = 'POSITION_SEAT_OPTION';

export const UPDATE_SEAT_OPTION = 'UPDATE_SEAT_OPTION';
